const currentUrl = typeof window !== "undefined" ? window.location.href : "";

const isQaRuntime =
  currentUrl.includes("127.0.0.1") ||
  currentUrl.includes("localhost") ||
  currentUrl.includes("https://website.sodevadiraja.com:444/") ||
  currentUrl.includes("https://qaweb.kamadhenutrust.com/");

const isProdRuntime = [
  "https://www.sodematha.in/",
  "https://www.test.sodematha.in/",
  "https://prod.sodematha.in/",
].some((url) => currentUrl.includes(url));

const useProdRuntime = !isQaRuntime && isProdRuntime;

// Match the existing website's sode-paryaya/js/env.js defaults. Build-time
// environment values continue to override these public API settings.
const defaultApiBaseUrl = useProdRuntime
  ? "https://app.sodevadiraja.com/api"
  : "https://app-qa.sodematha.in/api";
const defaultInstitutionReference = useProdRuntime
  ? "ins_858371d1bfcc44f7a529c4a0e38da290"
  : "ins_168a4fc305ea444088c597defd05c85d";

const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (useProdRuntime ? process.env.REACT_APP_PROD_API_BASE_URL : process.env.REACT_APP_QA_API_BASE_URL) ||
  process.env.REACT_APP_SEVAS_API_BASE_URL ||
  process.env.REACT_APP_EVENTS_API_ENDPOINT?.replace(/\/event$/, "") ||
  defaultApiBaseUrl;

const eventsApiBaseUrl =
  process.env.REACT_APP_EVENTS_API_BASE_URL ||
  process.env.REACT_APP_PROD_API_BASE_URL ||
  process.env.REACT_APP_EVENTS_API_ENDPOINT?.replace(/\/event$/, "") ||
  apiBaseUrl;

const sharedApiBaseUrl = apiBaseUrl?.replace(/\/$/, "").endsWith("/shared")
  ? apiBaseUrl.replace(/\/$/, "")
  : `${apiBaseUrl?.replace(/\/$/, "")}/shared`;

const eventsSharedApiBaseUrl = eventsApiBaseUrl?.replace(/\/$/, "").endsWith("/shared")
  ? eventsApiBaseUrl.replace(/\/$/, "")
  : `${eventsApiBaseUrl?.replace(/\/$/, "")}/shared`;

const institutionReference =
  process.env.REACT_APP_INSTITUTION_REFERENCE ||
  (useProdRuntime ? process.env.REACT_APP_PROD_INSTITUTION_REFERENCE : process.env.REACT_APP_QA_INSTITUTION_REFERENCE) ||
  process.env.REACT_APP_SEVAS_INSTITUTION_REFERENCE ||
  process.env.REACT_APP_EVENTS_INSTITUTION_REFERENCE ||
  defaultInstitutionReference;

const eventsInstitutionReference =
  process.env.REACT_APP_EVENTS_INSTITUTION_REFERENCE ||
  process.env.REACT_APP_PROD_INSTITUTION_REFERENCE ||
  institutionReference;

const cashfreeMode = (useProdRuntime ? process.env.REACT_APP_PROD_CASHFREE_MODE : process.env.REACT_APP_QA_CASHFREE_MODE) ||
  (useProdRuntime ? "production" : "sandbox");

const roomApiBaseUrl =
  process.env.REACT_APP_ROOM_API_BASE_URL ||
  (useProdRuntime ? process.env.REACT_APP_PROD_ROOM_API_BASE_URL : process.env.REACT_APP_QA_ROOM_API_BASE_URL) ||
  sharedApiBaseUrl;

const roomInstitutionReference =
  process.env.REACT_APP_ROOM_INSTITUTION_REFERENCE ||
  (useProdRuntime ? process.env.REACT_APP_PROD_ROOM_INSTITUTION_REFERENCE : process.env.REACT_APP_QA_ROOM_INSTITUTION_REFERENCE) ||
  institutionReference;

const roomCashfreeMode =
  (useProdRuntime ? process.env.REACT_APP_PROD_ROOM_CASHFREE_MODE : process.env.REACT_APP_QA_ROOM_CASHFREE_MODE) ||
  cashfreeMode;

export const API_CONFIG = {
  apiBaseUrl,
  sharedApiBaseUrl,
  eventsApiBaseUrl,
  eventsSharedApiBaseUrl,
  eventsEndpoint: `${eventsSharedApiBaseUrl}/event`,
  eventsCdnUrl: process.env.REACT_APP_CDN_URL || process.env.REACT_APP_EVENTS_CDN_URL,
  eventsInstitutionReference,
  institutionReference,
  sevasBaseUrl: sharedApiBaseUrl,
  sevasInstitutionReference: institutionReference,
  cashfreeMode,
  roomApiBaseUrl,
  roomInstitutionReference,
  roomCashfreeMode,
};

export const joinCdnUrl = (base = "", path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${base.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
};
